import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { IRegionGroupListRecord } from "../../npr-request.model";

@Component({
  standalone: false,
  selector: "app-insert-customer-region-modal",
  templateUrl: "./insert-customer-region-modal.component.html",
  styleUrls: ["../../styles.scss"],
})
export class InsertCustomerRegionModalComponent
{
  @Input() regionsList: IRegionGroupListRecord[] = [];
  
  billingAccountId = "";
  selectedRegion = "";
  
  constructor(public activeModal: NgbActiveModal) {}

  onSubmit()
  {
    if (this.billingAccountId && this.selectedRegion)
    {
      this.activeModal.close({
        BillingAccountId: this.billingAccountId,
        Region: this.selectedRegion,
      });
    }
  }

  onCancel()
  {
    this.activeModal.dismiss();
  }
}
